import { render, staticRenderFns } from "./changePassword.vue?vue&type=template&id=3cf2c962"
import script from "./changePassword.ts?vue&type=script&lang=js&external"
export * from "./changePassword.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports